/**
 * @generated SignedSource<<854e0ae910c8efde274642f6105bfbfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopifyTab_brand$data = {
  readonly appConfig: {
    readonly androidAppStoreLink: string | null;
    readonly appIconUrl: string | null;
    readonly iosAppStoreLink: string | null;
  };
  readonly shopifyConfig: {
    readonly appEmbedUrl: string | null;
    readonly isConnected: boolean;
    readonly multipassEnabled: boolean;
    readonly shopifyUrl: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerAccountsCard_brand" | "useBrandUpdateMutation_brand">;
  readonly " $fragmentType": "ShopifyTab_brand";
};
export type ShopifyTab_brand$key = {
  readonly " $data"?: ShopifyTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopifyTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopifyTab_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandUpdateMutation_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomerAccountsCard_brand"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandShopifyConfigType",
      "kind": "LinkedField",
      "name": "shopifyConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appEmbedUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shopifyUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isConnected",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "multipassEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appIconUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppStoreLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidAppStoreLink",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "2eba45c1e61f8ab06d3d45553278e2f2";

export default node;
